// src/components/NotificationComponent.tsx
import React, { useEffect } from 'react';
import { NotificationService } from '../services/NotificationService';
import logger from '../utils/logger';

const NotificationComponent: React.FC = () => {
  useEffect(() => {
    const initializeNotifications = async () => {
      try {
        // Only initialize if user is logged in
        const authToken = localStorage.getItem('auth_token');
        if (!authToken) {
          logger.log('🔔 Notification: User not logged in, skipping initialization');
          return;
        }

        const service = NotificationService.getInstance();
        await service.initialize();

        // Request permission after login
        if (Notification.permission === 'default') {
          await Notification.requestPermission();
        }
      } catch (err) {
        console.error('Notification initialization failed:', err);
      }
    };

    initializeNotifications();
  }, []);

  return null;
};

export default NotificationComponent;